<template>
    <Button
        class="p-button-raised"
        :label="label"
        :icon="icon"
        :badge="badge"
        :loading="loading"
        :class="{'p-button-primary': !outline, 'p-button-outlined': outline, 'p-button-rounded': rounded}"
        :disabled="disabled"
    >
    </Button>
</template>

<script lang="ts">
import Button from 'primevue/button';
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    label: String,
    icon: String,
    badge: String,
    loading: Boolean,
    outline: Boolean,
    rounded: Boolean,
    disabled: Boolean
  }
})
export default class ButtonComponent extends Vue {
  label = "";
  icon = "";
  badge = '';
  loading = false;
  outline = false;
  rounded = false;
  disabled = false;


}

</script>

<style scoped>

@import url('https://unpkg.com/primevue@^3/resources/themes/saga-blue/theme.css');
@import url('https://unpkg.com/primevue@^3/resources/primevue.min.css');
@import url('https://unpkg.com/primeflex@^3/primeflex.min.css');
@import url('https://unpkg.com/primeicons/primeicons.css');

</style>